//将xxx.js替换成需要发布的配置js文件
import {
	apiMall,
	javaApi,
	appName,
	isOverseas,
	unit,
	footCopyrightInfo,
	footRecordInformation,
	footGongAnBeianHref,
	footGongAnBeianInformation,
	appId,
	isH5,
	h5Url,
	scanToOrderMsg,
	conactTel,
	footRecordInformationLink,
	hideBuyButton,
	isTouchScreen
} from '@/api/config/prod_younglife.js'
export const config = {
	apiMall,
	javaApi,
	appName,
	isOverseas,
	unit,
	footCopyrightInfo,
	footRecordInformation,
	footGongAnBeianHref,
	footGongAnBeianInformation,
	appId,
	isH5,
	h5Url,
	scanToOrderMsg,
	conactTel,
	footRecordInformationLink,
	hideBuyButton,
	isTouchScreen
}
